import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import IndTemplateBreadcrumb from '../../data-collection/indicators/components/IndTemplateBreadcrumb';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { fetchReportsList } from '../reportIndicatorsApi';
import { RootState, useAppDispatch } from '../../../app/store';
import { url } from 'inspector';
import { useSelector } from 'react-redux';

const currentYear = new Date().getFullYear();

const ReportIndicators: React.FC = () => {
    const { indicatorId } = useParams(); // This will give you the id from the URL
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const indicatorIds = [11, 13, 15, 16, 9, 14];
    const { reportsData } = useSelector((state: RootState) => state.reportsData);

    useEffect(() => {
        if (indicatorId && indicatorIds.includes(parseInt(indicatorId))) {
            const finalObj = {
                id: indicatorId,
            };

            // if (indicatorId != undefined) {
            dispatch(fetchReportsList(finalObj));
            // }
        }
    }, [dispatch, indicatorId]);

    return (
        <>

            <div>
                <Row className='mainTextArea' style={{ width: '100%' }}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} >
                        <Row gutter={[16, 16]} style={{ borderBottom: '1px solid #CCC', marginBottom: '10px', paddingBottom: '10px' }}>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} >
                                <IndTemplateBreadcrumb separator='>' indicatorId={indicatorId ? parseInt(indicatorId) : 13} />
                            </Col>

                        </Row>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} >
                        {indicatorId && indicatorIds.includes(parseInt(indicatorId)) ?

                            <div className='IndicatorIframeHolder' style={{ paddingBottom: '50px' }}>
                                
                                {
                                    reportsData?.embedUrl ?
                                        <PowerBIEmbed
                                            embedConfig={{
                                                type: 'report',   // Supported types: report, dashboard, tile, visual, qna, paginated report and create
                                                id: reportsData?.reportId,
                                                embedUrl: reportsData?.embedUrl,
                                                accessToken: reportsData?.embedtoken,
                                                tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
                                                settings: {
                                                    panes: {
                                                        filters: {
                                                            expanded: false,
                                                            visible: false
                                                        }
                                                    }
                                                }
                                            }}

                                            eventHandlers={
                                                new Map([
                                                    // ['loaded', function () { console.log('Report loaded'); }],
                                                    // ['rendered', function () { console.log('Report rendered'); }],
                                                    // ['error', function (event) { console.log(event.detail); }],
                                                    // ['visualClicked', () => console.log('visual clicked')],
                                                    // ['pageChanged', (event) => console.log(event)],
                                                ])
                                            }

                                            cssClassName={"Embed-Container"}

                                        // getEmbeddedComponent={(embeddedReport) => {
                                        //     if (this) {
                                        //         this.report = embeddedReport;
                                        //     }
                                        // }}
                                        /> :

                                        <></>}

                                        {/* <iframe src="https://app.powerbi.com/reportEmbed?reportId=189b994a-45e9-404f-b2de-1f2c214fc2e8&autoAuth=true&ctid=73380db9-9031-4236-b6ce-938231940f53" /> */}

                            </div>
                            :
                            <h3 style={{ textAlign: 'center' }}>Data Not Found</h3>
                        }

                    </Col>
                </Row>
            </div >

        </>
    );

};

export default ReportIndicators;
